import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["subtitle", "title", "icon"];
import { CertificationIcon } from 'foundations-assets/icons/components/CertificationIcon';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Flex } from 'foundations-components/components/Flex';
import { H4 } from 'foundations-components/transitional/components/H4';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SectionHeading = ({
  children,
  icon,
  marginBlockEnd = '100',
  subText,
  use = 'on-light'
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(Text, {
      as: isMobile ? 'h4' : 'h2',
      color: use === 'on-dark' ? 'text-core-on-fill-default' : 'text-core-default',
      display: "inline-block",
      marginBlockEnd: marginBlockEnd,
      children: children
    }), icon && /*#__PURE__*/_jsx(IconHolder, {
      color: "fill-accent-orange-default",
      icon: CertificationIcon,
      size: isMobile ? '300' : '500'
    }), subText && /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "300",
      marginBlockStart: isMobile ? '200' : '100',
      children: subText
    })]
  });
};
export const PageSectionHeading = _ref => {
  let {
      subtitle,
      title,
      icon
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(View, Object.assign({
    marginBlockEnd: "400"
  }, props, {
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "200",
      children: [/*#__PURE__*/_jsx(H4, {
        marginBlockEnd: "0",
        children: title
      }), icon]
    }), subtitle ? /*#__PURE__*/_jsx(Text, {
      marginBlockStart: "200",
      children: subtitle
    }) : null]
  }));
};
export default SectionHeading;